var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.538 12.9973C22.5247 12.5324 21.4275 12.195 20.2846 12C20.2746 11.9997 20.2646 12.0016 20.2554 12.0055C20.2462 12.0093 20.2379 12.0152 20.2313 12.0225C20.0941 12.27 19.9341 12.5924 19.8274 12.8398C18.6152 12.6599 17.3824 12.6599 16.1702 12.8398C16.0635 12.5849 15.9035 12.27 15.7588 12.0225C15.7511 12.0075 15.7283 12 15.7054 12C14.5625 12.195 13.473 12.5324 12.452 12.9973C12.4444 12.9973 12.4368 13.0048 12.4291 13.0123C10.3567 16.064 9.78526 19.0332 10.0672 21.9724C10.0672 21.9874 10.0748 22.0024 10.09 22.0099C11.4615 22.9997 12.7796 23.5995 14.0825 23.9969C14.1054 24.0044 14.1282 23.9969 14.1359 23.9819C14.4406 23.5695 14.7149 23.1346 14.9511 22.6772C14.9664 22.6472 14.9511 22.6173 14.9206 22.6098C14.4863 22.4448 14.0749 22.2499 13.6711 22.0249C13.6406 22.0099 13.6406 21.9649 13.6635 21.9424C13.7473 21.8824 13.8311 21.815 13.9149 21.755C13.9301 21.74 13.953 21.74 13.9682 21.7475C16.5893 22.9247 19.416 22.9247 22.0065 21.7475C22.0218 21.74 22.0446 21.74 22.0599 21.755C22.1437 21.8225 22.2275 21.8824 22.3113 21.9499C22.3418 21.9724 22.3418 22.0174 22.3037 22.0324C21.9075 22.2648 21.4884 22.4523 21.0541 22.6173C21.0237 22.6248 21.016 22.6622 21.0237 22.6847C21.2675 23.1421 21.5418 23.577 21.8389 23.9894C21.8618 23.9969 21.8846 24.0044 21.9075 23.9969C23.218 23.5995 24.5361 22.9997 25.9076 22.0099C25.9228 22.0024 25.9305 21.9874 25.9305 21.9724C26.2657 18.5758 25.3743 15.6291 23.5685 13.0123C23.5609 13.0048 23.5533 12.9973 23.538 12.9973ZM15.3473 20.1804C14.5625 20.1804 13.9073 19.4681 13.9073 18.5908C13.9073 17.7135 14.5473 17.0012 15.3473 17.0012C16.155 17.0012 16.795 17.721 16.7874 18.5908C16.7874 19.4681 16.1473 20.1804 15.3473 20.1804ZM20.6579 20.1804C19.8732 20.1804 19.2179 19.4681 19.2179 18.5908C19.2179 17.7135 19.8579 17.0012 20.6579 17.0012C21.4656 17.0012 22.1056 17.721 22.098 18.5908C22.098 19.4681 21.4656 20.1804 20.6579 20.1804Z",
    fill: "url(#paint0_linear_2451_52916)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2451_52916",
    x1: 10,
    y1: 18,
    x2: 26,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0387F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED4B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity4);
export default __webpack_public_path__ + "static/media/community_4.e2b674b319789f5e20cf153709bb9345.svg";
export { ForwardRef as ReactComponent };